import axios from 'axios'

export default {
  namespaced: true,
  state() {
    return {
      name: '',
      surname: '',
      mail: '',
      tel: '',
      address: '',
      city: '',
      region: '',
      country: '',
      language: '',
      oldPass: '',
      postalCode: '',
      avatar: '',
      photoUpload: '',
      authBy: '',
      validCenter: true,
      validRight: true,
      dirt: false,
    }
  },
  getters: {
    valid: state => {
      return (state.validCenter && state.validRight) === true
    }
  },
  mutations: {
    SET_AUTH_BY(state,data) {
      state.authBy = data
    },
    SET_DIRT(state,data) {
      state.dirt = data
    },
    SET_NAME(state,data) {
      state.name = data
    },
    SET_AVATAR(state,data) {
      state.avatar = data
    },
    SET_PHOTO(state,data) {
      state.photoUpload = data
    },
    SET_SURNAME(state,data) {
      state.surname = data
    },
    SET_MAIL(state,data) {
      state.mail = data
    },
    SET_TEL(state,data) {
      state.tel = data
    },
    SET_ADDRESS(state,data) {
      state.address = data
    },
    SET_CITY(state,data) {
      state.city = data
    },
    SET_REGION(state,data) {
      state.region = data
    },
    SET_COUNTRY(state, data) {
      state.country = data
    },
    SET_LANGUAGE(state,data) {
      state.language = data
    },
    SET_POSTAL_CODE(state,data) {
      state.postalCode = data
    },
    SET_VALID_CENTER(state,data) {
      state.validCenter = data
    },
    SET_VALID_RIGHT(state,data) {
      state.validRight = data
    },
    SET_OLD_PASS(state,data) {
      state.oldPass = data
    }
  },
  actions: {
    async updateUser({state,commit, rootState}, user) {
      let url = process.env.VUE_APP_URL + 'profile/update';
      axios.post(url, user, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': '*/*',
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
      }).catch((e) => {})
    },
    async updateUserPass({commit, rootState},pass) {
      let url = process.env.VUE_APP_URL + 'profile/password-change';

      await axios({
        method: 'post',
        data: pass,
        url: url,
        headers: {
          'Authorization': rootState.auth.token
        }
      })
    }
  }
}
